export default "__VITE_ASSET__DYnOfsoI__"